import { type GetSrcArgs, defaultGetSrc } from 'openimg/react'

export function getUserImgSrc(objectKey?: string | null) {
    return objectKey
        ? `/resources/images?objectKey=${encodeURIComponent(objectKey)}`
        : '/img/user.png'
}

export function getNoteImgSrc(objectKey: string) {
    return `/resources/images?objectKey=${encodeURIComponent(objectKey)}`
}

export function getLayoutImgSrc(objectKey: string) {
    return `/resources/images?objectKey=${encodeURIComponent(objectKey)}`
}

export function getImgSrc({ height, optimizerEndpoint, src, width, fit, format }: GetSrcArgs) {
    // We customize getImgSrc so our src looks nice like this:
    // /resources/images?objectKey=...&h=...&w=...&fit=...&format=...
    // instead of this:
    // /resources/images?src=%2Fresources%2Fimages%3FobjectKey%3D...%26w%3D...%26h%3D...
    if (src.startsWith(optimizerEndpoint)) {
        const [endpoint, query] = src.split('?')
        const searchParams = new URLSearchParams(query)
        searchParams.set('h', height.toString())
        searchParams.set('w', width.toString())
        if (fit) {
            searchParams.set('fit', fit)
        }
        if (format) {
            searchParams.set('format', format)
        }
        return `${endpoint}?${searchParams.toString()}`
    }
    return defaultGetSrc({ height, optimizerEndpoint, src, width, fit, format })
}
